const FileSize = {
  TRANSACTION_FILE_SIZE: 1024,
  SELECT_SIZE: 30000,
};

export default FileSize;
